<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl card font-bold">
                  My Account
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <div class="grid">
                      <div class="col-12">
                        <template v-if="pageReady">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="p-4">
                              <div class="grid">
                                <div class="col">
                                  <div class="text-2xl text-primary">
                                    # {{ $auth.userName }}
                                  </div>
                                  <div class="text-sm text-gray-500 mt-2">
                                    {{ $auth.userEmail }}
                                  </div>
                                  <div
                                    class="text-sm text-500 text-capitalize py-2"
                                    v-if="$auth.userRole"
                                  >
                                    Access Level: {{ $auth.userRole }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <TabView v-model:activeIndex="activeTab">
                              <TabPanel>
                                <template #header>
                                  <i class="pi pi-user mr-2"></i>
                                  <span>Account Detail</span>
                                </template>
                                <div>
                                  <div
                                    class="text-xl font-bold mb-1"
                                  >
                                    Account Details
                                  </div>
                                  <div class="mb-4">
                                    Information you have provided about this
                                    account
                                  </div>
                                  <hr />
                                </div>
                                <div>
                                  <div class="grid align-items-center">
                                    <div class="col">First Name:</div>
                                    <div class="col font-bold">
                                      {{ item.first_name }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">Last Name:</div>
                                    <div class="col font-bold">
                                      {{ item.last_name }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">Email:</div>
                                    <div class="col font-bold">
                                      {{ item.email }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">Telephone:</div>
                                    <div class="col font-bold">
                                      {{ item.telephone }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">Region:</div>
                                    <div class="col font-bold">
                                      {{ item.region }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">District:</div>
                                    <div class="col font-bold">
                                      {{ item.district }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">Date Created:</div>
                                    <div class="col font-bold">
                                      {{
                                        $utils.humanDatetime(item.date_created)
                                      }}
                                    </div>
                                  </div>
                                  <hr />
                                  <div class="grid align-items-center">
                                    <div class="col">Last Updated:</div>
                                    <div class="col font-bold">
                                      {{
                                        $utils.humanDatetime(item.date_updated)
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </TabPanel>
                              <TabPanel>
                                <template #header>
                                  <i class="pi pi-pencil mr-2"></i>
                                  <span>Edit Account</span>
                                </template>
                                <div class="reset-grid">
                                  <account-edit-page></account-edit-page>
                                </div>
                              </TabPanel>
                              <TabPanel>
                                <template #header>
                                  <i class="pi pi-lock mr-2"></i>
                                  <span>Change Password</span>
                                </template>
                                <div class="reset-grid">
                                  <change-password-page></change-password-page>
                                </div>
                              </TabPanel>
                            </TabView>
                          </div>
                        </template>
                        <template v-if="loading">
                          <div class="q-pa-lg text-center">
                            <ProgressSpinner
                              style="width: 50px; height: 50px"
                            />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 md:col-4 comp-grid animate__animated animate__fadeIn animate__faster hidden-xs hidden-sm"
          >
            <div
              class="sticky-item"
              :style="`height: 80vh; background-image: linear-gradient(357deg, rgb(255 255 255 / 97%), rgb(255 255 255 / 22%)), url('images/call_woman.png'); background-repeat: no-repeat;background-size: cover;`"
            ></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { ref, toRefs, onMounted } from "vue";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { utils } from "@/utils";
import AccountEditPage from "./accountedit.vue";
import ChangePasswordPage from "./changepassword.vue";
import { useViewPage } from "@/composables/viewpage.js";
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "user_id",
  },
  pageName: {
    type: String,
    default: "users",
  },
  routeName: {
    type: String,
    default: "usersaccountview",
  },
  apiPath: {
    type: String,
    default: "account",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const auth = useAuth();
const page = useViewPage(props);
const activeTab = ref(0);
//page state
const {
  item,
  loading,
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const { load, deleteItem } = page.methods;
onMounted(() => {
  const pageTitle = "My Account";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
